import React from "react";
import PropTypes from "prop-types";

const Button = props => (
  <button
    className={`button is-${props.size} is-${props.color} ${props.fullWidth &&
      "is-fullwidth"} ${props.isActive && "is-active"} ${props.isInverted &&
      "is-inverted"} ${props.isOutlined && "is-outlined"}`}
    onClick={props.onClick}
  >
    {props.children}
  </button>
);

Button.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]).isRequired,
  color: PropTypes.string,
  fullWidth: PropTypes.bool,
  isActive: PropTypes.bool,
  isInverted: PropTypes.bool,
  isOutlined: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.string
};

Button.defaultProps = {
  color: "brand",
  fullWidth: false,
  isActive: false,
  isInverted: false,
  isOutlined: false,
  size: "medium"
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.js